<template>
  <div id="top">
    <!--container-->
    <div class="innerWrapper">
      <h1>Property selection</h1>
      <h2>
        Before reserving the property, please select which<br />apartment it is
        you would like to reserve.
      </h2>
      <div class="allType clear">
        <div class="type clear"><i></i><span>Available properties</span></div>
        <div class="type clear"><i></i><span>Sold properties</span></div>
        <div class="type clear"><i></i><span>Reserved properties</span></div>
      </div>
      <ul class="list clear">
        <li v-for="(item, index) in datum" :key="index">
          <span
            :class="{
              reserved: item.status == 'Reserved',
              sold:
                item.status == 'Sold' ||
                item.status == 'Unconditional' ||
                item.status == 'Settled',
              available: item.status == 'Available',
              choosed: index == cur
            }"
            @click="choosed(index, item.roomId, item.status)"
            >{{ item.apt }}</span
          >
        </li>
      </ul>
      <button
        :class="{ disabled: disable }"
        :disabled="disable"
        class="continue"
        @click="next"
      >
        Continue
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      disable: true,
      cur: -1,
      curId: "",
      pm: {},
      datum: [],
      gray: true
    };
  },
  created() {
    var that = this;
    if (!that.$route.params.id) {
      that.$router.push("/");
      return false;
    }
    that.pm = that.$route.params;
    that.getPropertyRoomLst({ params: that.pm.id, callback: that.callback });
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    goBack() {
      var that = this;
      if (that.$route.params.id && that.$route.params.id !== undefined) {
        that.$router.replace(`/index/property/${that.$route.params.id}/room/0`);
      }
    },
    ...mapMutations("login", ["cleartime"]),
    ...mapActions("property", ["getPropertyRoomLst"]),
    next() {
      var that = this;
      if (that.disable) {
        return;
      }
      that.$router.push({
        path: `/private/write/${that.pm.id}/${that.curId}?publicFlag=${that.$route.query.publicFlag}&sessionId=${that.$route.query.sessionId}`,
        query: { from: 1 }
      });
      that.cleartime();
      // 重新选房间去掉存本地的数据
      localStorage.removeItem("cardType");
      localStorage.removeItem("signwarn");
      localStorage.removeItem("num");
      localStorage.removeItem("disable");
      localStorage.removeItem("signSurName");
      localStorage.removeItem("signFirName");
      localStorage.removeItem("allPurchaser");
      localStorage.removeItem("legal");
      localStorage.removeItem("cardInfo");
      localStorage.removeItem("agreementDate");
      localStorage.removeItem("agreementDateWarn");
      localStorage.removeItem("agreementName");
      localStorage.removeItem("agreementNameWarn");
      localStorage.removeItem("purchasingEntity");
      localStorage.removeItem("promisePurchaser");
      localStorage.removeItem("promiseLegal");
      localStorage.removeItem("promiseOther");
    },
    callback(res) {
      var that = this;
      if (res.data.code === 0) {
        that.datum = res.data.data;
      } /*else if (res.data.code === 90000 || res.data.code === 90002 || res.data.code === 90001) {
        localStorage.clear()
        that.$router.push('/login')
      } else if (res.data.code === 8902 || res.data.code === 8901) {
        that.$box.alert('', res.data.message, 'error')
        localStorage.clear()
        that.$router.push('/login')
      } */ else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    choosed(index, roomId, status) {
      if (status === "Available") {
        var that = this;
        that.cur = index;
        that.curId = roomId;
        that.disable = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.innerWrapper {
  width: 100%;
  padding: 1.52rem 0.24rem 0 0.24rem;
  box-sizing: border-box;

  h1 {
    font-size: 0.56rem;
    line-height: 0.68rem;
    color: #2a2929;
    margin-bottom: 0.32rem;
    font-family: ProximaNova-Semibold;
  }

  h2 {
    font-size: 0.28rem;
    line-height: 0.42rem;
    margin-bottom: 0.8rem;
    word-break: break-word;
  }

  .allType {
    margin-bottom: 0.8rem;

    .type {
      margin: 0 auto 0.32rem auto;
      line-height: 0.48rem;

      i {
        width: 0.48rem;
        height: 0.48rem;
        border-radius: 0.12rem;
        box-sizing: border-box;
        margin: 0 0.2rem 0 1.6rem;
        float: left;
      }

      span {
        float: left;
        font-size: 0.28rem;
        width: 3rem;
      }
    }

    .type:nth-child(1) {
      i {
        border: 0.03rem solid #dad7db;
      }
    }

    .type:nth-child(2) {
      i {
        background: #f3f0f3;
      }
    }

    .type:nth-child(3) {
      margin-bottom: 0;

      i {
        background: #ebfaf2;
      }
    }
  }

  .list {
    margin-bottom: 0.4rem;

    li {
      width: 50%;
      height: 0.92rem;
      float: left;
      margin-bottom: 0.22rem;
      box-sizing: border-box;

      span {
        display: block;
        width: 100%;
        height: 0.92rem;
        border-radius: 0.12rem;
        font-size: 0.3rem;
        line-height: 0.92rem;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;
      }
    }

    li:nth-child(1n) {
      padding-right: 0.11rem;
    }

    li:nth-child(2n) {
      padding-left: 0.11rem;
    }

    .available {
      border: 0.03rem solid #dad7db;
      color: #3f3f46;
    }

    .sold {
      border: 0.03rem solid #f3f0f3;
      background: #f3f0f3;
      color: #787878;
    }

    .reserved {
      border: 0.03rem solid #ebfaf2;
      background: #ebfaf2;
      color: #787878;
      cursor: not-allowed;
    }

    .choosed {
      border: 0.03rem solid #423e46;
      background: #423e46;
      color: #fff;
    }
  }

  .continue {
    display: block;
    margin: 0 auto 80px auto;
    width: 5.18rem;
    height: 0.92rem;
    border-radius: 0.12rem;
    font-size: 0.3rem;
    text-align: center;
    background: #2dc874;
    border: none;
    color: #fff;
    cursor: pointer;
  }

  .disabled {
    background: #a2e3c0;
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/private/property/selection.vue